* {
    box-sizing: border-box;
}

:host {
    display: block;
    background-color: var(--color-background);
    max-width: 640px;
    max-height: 80vh;
    border-radius: 20px;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
    --zindex: calc(var(--zindex-base, 0) + var(--zindex-modal, 3100));
    z-index: calc(0 + 3100);
    z-index: var(--zindex);
    pointer-events: all;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

::slotted(*) {
    --zindex-base: var(--zindex);
}

.close {
    position: absolute;
    top: -45px;
    right: -45px;
    border: 0;
    width: 90px;
    height: 90px;
    background-color: var(--color-secondary);
    color: var(--color-secondary-contrast);
    border: 1px solid var(--color-secondary);
    border-radius: 50%;
    padding: 12px;
    padding-top: 50px;
    padding-right: 50px;
    cursor: pointer;
    transition-property: color, background-color;
    transition-duration: 500ms;
    transition-timing-function: ease;
    outline: none;
}

.close:hover,
    .close:focus {
        background-color: var(--color-secondary-contrast);
        color: var(--color-secondary);
    }

header {
    border-bottom: 5px solid var(--color-shade-20);
    padding: 32px 30px;
    padding-bottom: 0;
    margin: 0;
}

::slotted(h1[slot='header']) {
    font-weight: 100;
    font-size: 36px;
    color: var(--color-text);
    margin: 0;
    margin-bottom: 23px;
}

::slotted(h2[slot='header']) {
    font-weight: 400;
    font-size: 16px;
    color: var(--color-text);
    margin: 0;
    margin-bottom: 17px;
}

.body {
    padding: 15px 30px;
    overflow: auto;
    overscroll-behavior: none;
}

footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 32px 30px;
    padding-top: 0;
    margin: 0;
}

::slotted(*[slot='footer']) {
    margin-left: 10px;
}
